import { useDispatch, useSelector } from 'react-redux'

import { quoteActions } from '../../store/quote-slice'

import classes from './AirportTransfers.module.css'
import React from 'react'

const AirportTransfers = () => {
  const dispatch = useDispatch()

  const airportPickUp = useSelector((state) => state.quote.airportPickUp)

  const airportDropOff = useSelector((state) => state.quote.airportDropOff)


  const airportPickupChangeHandler = () => {
    dispatch(quoteActions.setAirportPickUpToggle({}))
  }

  const airportDropoffChangeHandler = () => {
    dispatch(quoteActions.setAirportDropOffToggle())
  }


  //weekDay
  //fullDate

  return (
    <React.Fragment>
        <div className={classes.transferContainer}>

              <div
                className={`${classes.transferPickupContainer} ${classes.transferIcon}`}
              >
                <p className={classes.headerText}>Airport Pickup</p>
                <p className={classes.description}>
                  {airportPickUp ? 'Pickup from Phuket Airport' : 'Not Required'}
                </p>
                <button 
                onClick={airportPickupChangeHandler}
                className={`${classes.taxiButton}  ${airportPickUp ? classes.removeTaxi : classes.addTaxi}`
                
              }
                >
                  {airportPickUp ? 'Remove' : 'Add'}
                </button>
              </div>


              <div
                className={`${classes.transferPickupContainer} ${classes.transferIcon}`}
              >
                <p className={classes.headerText}>Airport Drop Off</p>
                <p className={classes.description}>
                  {airportDropOff ? 'Drop off to Phuket Airport' : 'Not Required'}
                </p>
                <button 
                onClick={airportDropoffChangeHandler}
                className={`${classes.taxiButton}  ${airportDropOff ? classes.removeTaxi : classes.addTaxi}`
                
              }
                >
                  {airportDropOff ? 'Remove' : 'Add'}
                </button>
              </div>                        
        </div>
    </React.Fragment>
  )
}

export default AirportTransfers
